<template>
	<!-- <PullRefresh @on-refresh="handleRefresh">
		<slot />
	</PullRefresh> -->
	<Vue3PullToRefresh
		:distance="100"
		:duration="2000"
		:size="46"
		:options="{ color: 'var(--red)', bgColor: '#1e1e1e', className: 'custom-ptr' }"
	>
	</Vue3PullToRefresh>
</template>

<script setup lang="ts">
	// import { PullRefresh } from "@amirafa/vue3-pull-to-refresh"
	import Vue3PullToRefresh from "@amirafa/vue3-pull-to-refresh"
	const emit = defineEmits<{
		refresh: []
	}>()

	const handleRefresh = (done: () => void) => {
		// Emit refresh event to parent
		emit("refresh")
		window.location.reload()
	}
</script>

<style scoped>
	/* Pull to refresh custom styling */
	:deep(.pull-refresh-container) {
		position: relative;
		overflow-y: auto;
	}

	:deep(.pull-refresh-header) {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px;
		color: var(--color-text-secondary, #888);
		font-size: 14px;
	}
</style>
